import { Injectable } from '@angular/core';
import {
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    Router
} from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class AdminAuthGuard implements CanActivate {

    constructor(private router: Router) { }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean {

        const token = localStorage.getItem('iosc_admin_token');

        if (token) {
            return true;
        }

        this.router.navigate(['/admin/login'], {
            queryParams: {
                returnUrl: state.url
            }
        });

        return false;
    }
}